import { render, staticRenderFns } from "./xcxIndex.vue?vue&type=template&id=0a156b2d&"
import script from "./xcxIndex.vue?vue&type=script&lang=js&"
export * from "./xcxIndex.vue?vue&type=script&lang=js&"
import style0 from "./xcxIndex.vue?vue&type=style&index=0&id=0a156b2d&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports